import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TaxTotalsType  {
    _originalTypeClassName = "zERP.BO.TaxTotalsType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TaxTotalsType.translate = translateService;
}
this.ExternalSystemInfo = [];
this.Id = null;
this.UnderlyingValue = null;
this.TaxAmount = null;
this.IsIdSpecified = false;
this.TaxType = null;
this.TaxCategory = null;
this.TaxTypeEnum = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
UnderlyingValue:any;
TaxAmount:any;
IsIdSpecified:any;
TaxType:any;
TaxCategory:any;
TaxTypeEnum:any;
Tax:any;
PaymentOrderDeductionDetail:any;
ExternalSystemInfo:any;
static setTax = ($this, value) => {
var oldValue = $this.Tax;
$this.Tax = value;
if (value != null) {
}
}
static setPaymentOrderDeductionDetail = ($this, value) => {
var oldValue = $this.PaymentOrderDeductionDetail;
$this.PaymentOrderDeductionDetail = value;
if (value != null) {
if (oldValue != null && oldValue.TaxTotalsType != null) { oldValue.TaxTotalsType = null; }
if ($this.PaymentOrderDeductionDetail.TaxTotalsType !== $this) {
Domain.PaymentOrderDeductionDetail.setTaxTotalsType(value, $this);
}
}
}
static setExternalSystemInfo = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExternalSystemInfo == null) $this.ExternalSystemInfo = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExternalSystemInfo.length > 0) {
                    Domain.TaxTotalsType.removeExternalSystemInfo($this, $this.ExternalSystemInfo[0]);
                }

                Domain.TaxTotalsType.addManyExternalSystemInfo($this, copyItems);
            }
static addManyExternalSystemInfo = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TaxTotalsType.addExternalSystemInfo($this, items[i]);
                }
            }
static addExternalSystemInfo = ($this, item) => {
                if ($this.ExternalSystemInfo == null) $this.ExternalSystemInfo = [];
                if (item == null || $this.ExternalSystemInfo.indexOf(item) > -1) return;
                $this.ExternalSystemInfo.push(item);
}
static addRangeExternalSystemInfo = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TaxTotalsType.addExternalSystemInfo($this, item));
            }
static removeExternalSystemInfo = ($this, item) => {
                if ($this == null || $this.ExternalSystemInfo == null || $this.ExternalSystemInfo.indexOf(item) === -1) return;
                var _index = $this.ExternalSystemInfo.indexOf(item);
                $this.ExternalSystemInfo.splice(_index, 1);
}
static clearExternalSystemInfo = ($this) => { $this.ExternalSystemInfo = null; }

static TaxTypeEnumToInt(taxType: any): any{switch (taxType) {case Domain.TaxType.WithHeld:
{
return 1;}
case Domain.TaxType.Fees:
{
return 2;}
case Domain.TaxType.OtherTax:
{
return 3;}
case Domain.TaxType.StampDuty:
{
return 4;}
case Domain.TaxType.Deduction:
{
return 5;}
default:
{
return 0;}
}
}
static TaxTypeIntToEnum(taxType: any): any{switch (taxType) {case 1:
{
return Domain.TaxType.WithHeld;}
case 2:
{
return Domain.TaxType.Fees;}
case 3:
{
return Domain.TaxType.OtherTax;}
case 4:
{
return Domain.TaxType.StampDuty;}
case 5:
{
return Domain.TaxType.Deduction;}
default:
{
return Domain.TaxType.Empty;}
}
}
static UpdateCategoryAndType($this: any): any{if ($this?.Tax == null) {return;}
$this.TaxType = Domain.TaxTotalsType.TaxTypeEnumToInt($this?.Tax?.Type);
$this.TaxCategory = $this?.Tax?.MyDataCode;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}